(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const storageKey = 'newloco:favorites';

    const readFavorites = () => {
      try {
        const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
        return Array.isArray(value) ? value.map(String) : [];
      } catch (error) {
        return [];
      }
    };

    const writeFavorites = (favorites) => {
      try {
        localStorage.setItem(storageKey, JSON.stringify(favorites));
      } catch (error) {
        return;
      }
    };

    const updateButton = (button, favorites) => {
      const isActive = favorites.includes(String(button.dataset.productId));
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
      button.setAttribute('aria-label', isActive ? button.dataset.labelRemove : button.dataset.labelAdd);
    };

    const syncButtons = (root = document) => {
      const favorites = readFavorites();
      root.querySelectorAll('[data-nl-favorite]').forEach((button) => updateButton(button, favorites));
    };

    const parseInteger = (value, fallback = 0) => {
      const parsed = Number.parseInt(value, 10);
      return Number.isFinite(parsed) ? parsed : fallback;
    };

    const isWeekend = (date) => date.getDay() === 0 || date.getDay() === 6;

    const addDays = (date, days, useBusinessDays) => {
      const next = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      let remaining = Math.max(0, days);

      while (remaining > 0) {
        next.setDate(next.getDate() + 1);

        if (!useBusinessDays || !isWeekend(next)) {
          remaining -= 1;
        }
      }

      if (useBusinessDays) {
        while (isWeekend(next)) {
          next.setDate(next.getDate() + 1);
        }
      }

      return next;
    };

    const getFulfillmentStartDate = (now, cutoffHour, useBusinessDays) => {
      const startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());

      if (now.getHours() >= cutoffHour) {
        return addDays(startDate, 1, useBusinessDays);
      }

      if (useBusinessDays && isWeekend(startDate)) {
        return addDays(startDate, 1, useBusinessDays);
      }

      return startDate;
    };

    const formatDateLabel = (date, locale) => {
      const safeLocale = locale || 'tr-TR';
      const month = new Intl.DateTimeFormat(safeLocale, { month: 'long' }).format(date);
      const formattedMonth = month.charAt(0).toLocaleUpperCase(safeLocale) + month.slice(1);

      return `${date.getDate()} ${formattedMonth}`;
    };

    const formatDateRange = (startDate, endDate, locale) => {
      if (startDate.getTime() === endDate.getTime()) {
        return formatDateLabel(startDate, locale);
      }

      const sameMonth = startDate.getMonth() === endDate.getMonth() && startDate.getFullYear() === endDate.getFullYear();

      if (sameMonth) {
        const endLabel = formatDateLabel(endDate, locale).replace(`${endDate.getDate()} `, '');
        return `${startDate.getDate()} - ${endDate.getDate()} ${endLabel}`;
      }

      return `${formatDateLabel(startDate, locale)} - ${formatDateLabel(endDate, locale)}`;
    };

    const syncOrderProcesses = (root = document) => {
      root.querySelectorAll('[data-nl-order-process]').forEach((module) => {
        if (module.dataset.nlDynamicDates !== 'true') return;

        const now = new Date();
        const locale = module.dataset.nlLocale || document.documentElement.lang || 'tr-TR';
        const useBusinessDays = module.dataset.nlUseBusinessDays === 'true';
        const cutoffHour = parseInteger(module.dataset.nlCutoffHour, 16);
        const shippingMin = parseInteger(module.dataset.nlShippingMin, 1);
        const shippingMax = Math.max(shippingMin, parseInteger(module.dataset.nlShippingMax, shippingMin));
        const deliveryMin = parseInteger(module.dataset.nlDeliveryMin, 3);
        const deliveryMax = Math.max(deliveryMin, parseInteger(module.dataset.nlDeliveryMax, deliveryMin));
        const orderDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const fulfillmentStartDate = getFulfillmentStartDate(now, cutoffHour, useBusinessDays);
        const shippingStartDate = addDays(fulfillmentStartDate, shippingMin, useBusinessDays);
        const shippingEndDate = addDays(fulfillmentStartDate, shippingMax, useBusinessDays);
        const deliveryStartDate = addDays(fulfillmentStartDate, deliveryMin, useBusinessDays);
        const deliveryEndDate = addDays(fulfillmentStartDate, deliveryMax, useBusinessDays);
        const orderTitle = module.querySelector('[data-nl-order-title="order"]');
        const shippingTitle = module.querySelector('[data-nl-order-title="shipping"]');
        const deliveryTitle = module.querySelector('[data-nl-order-title="delivery"]');

        if (orderTitle) orderTitle.textContent = formatDateLabel(orderDate, locale);
        if (shippingTitle) shippingTitle.textContent = formatDateRange(shippingStartDate, shippingEndDate, locale);
        if (deliveryTitle) deliveryTitle.textContent = formatDateRange(deliveryStartDate, deliveryEndDate, locale);
      });
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-nl-favorite]');
      if (!button) return;

      const productId = String(button.dataset.productId);
      const favorites = readFavorites();
      const nextFavorites = favorites.includes(productId)
        ? favorites.filter((id) => id !== productId)
        : [...favorites, productId];

      writeFavorites(nextFavorites);
      document.querySelectorAll(`[data-nl-favorite][data-product-id="${productId}"]`).forEach((item) => updateButton(item, nextFavorites));
    });

    document.addEventListener('shopify:section:load', (event) => {
      syncButtons(event.target);
      syncOrderProcesses(event.target);
    });

    syncButtons();
    syncOrderProcesses();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newloco-main-product-enhanced"]) return;
  try {
    
  (() => {
    const storageKey = 'newloco:favorites';

    const readFavorites = () => {
      try {
        const value = JSON.parse(localStorage.getItem(storageKey) || '[]');
        return Array.isArray(value) ? value.map(String) : [];
      } catch (error) {
        return [];
      }
    };

    const writeFavorites = (favorites) => {
      try {
        localStorage.setItem(storageKey, JSON.stringify(favorites));
      } catch (error) {
        return;
      }
    };

    const updateButton = (button, favorites) => {
      const isActive = favorites.includes(String(button.dataset.productId));
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
      button.setAttribute('aria-label', isActive ? button.dataset.labelRemove : button.dataset.labelAdd);
    };

    const syncButtons = (root = document) => {
      const favorites = readFavorites();
      root.querySelectorAll('[data-nl-favorite]').forEach((button) => updateButton(button, favorites));
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-nl-favorite]');
      if (!button) return;

      const productId = String(button.dataset.productId);
      const favorites = readFavorites();
      const nextFavorites = favorites.includes(productId)
        ? favorites.filter((id) => id !== productId)
        : [...favorites, productId];

      writeFavorites(nextFavorites);
      document.querySelectorAll(`[data-nl-favorite][data-product-id="${productId}"]`).forEach((item) => updateButton(item, nextFavorites));
    });

    document.addEventListener('shopify:section:load', (event) => syncButtons(event.target));
    syncButtons();
  })();

  } catch(e) { console.error(e); }
})();
})();
